import React, { useContext } from 'react';
import styled from 'styled-components';
import DaysOfWeekPicker from '@grnhse/seedling/lib/azalea/components/purgatory/days_of_week_picker';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/form/layout'. 'app/webpack/javascripts/shared/DEPRECATED/components/form/layout.js' implicitly has an 'any' type.
import { FormField } from 'shared/DEPRECATED/components/form/layout';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/components/time_zone_select'. 'app/webpack/javascripts/shared/components/time_zone_select.js' implicitly has an 'any' type.
import TimeZoneSelect from 'shared/components/time_zone_select';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/components/time_select'. 'app/webpack/javascripts/shared/components/time_select.js' implicitly has an 'any' type.
import TimeSelect from 'shared/components/time_select';
import { withLocalePrefix } from 'shared/utils/translation';
import {
  ContentContainer,
  ContentDescription,
  ContentHeader,
  Required,
} from 'gdpr/components/components';
import Errors from '../../shared/errors';
import { DataRetentionRulesContext } from '../context';
import NotificationRecipients from './notification_recipients';

import { getDaysOfWeekPickerOptions } from 'shared/utils/get_days_of_week_options';

type Props = {
  daysOfWeek: Array<number>;
  emails: Array<string>;
  onChangeDaysOfWeek: any;
  onChangeEmails: any;
  onChangeSelectedUsers: any;
  onChangeTime: any;
  onChangeTimezone: any;
  selectedUsers: Array<{
    label: string;
    value: number;
  }>;
  time: any;
  timezone: any;
};

const t = withLocalePrefix('gdpr.data_retention_rules.view.edit.notifications');

export default function DeletionNotification(props: Props) {
  const {
    daysOfWeek,
    emails,
    onChangeDaysOfWeek,
    onChangeEmails,
    onChangeSelectedUsers,
    onChangeTime,
    onChangeTimezone,
    selectedUsers,
    time,
    timezone,
  } = props;
  const { errors } = useContext(DataRetentionRulesContext);

  // @ts-expect-error - TS2339 - Property 'time' does not exist on type '{}'. | TS2339 - Property 'time_zone' does not exist on type '{}'.
  const timeErrors = [...(errors.time || []), ...(errors.time_zone || [])];

  // @ts-expect-error - TS2339 - Property 'notification_recipients' does not exist on type '{}'.
  const recipientError = errors.notification_recipients &&
    // @ts-expect-error - TS2339 - Property 'notification_recipients' does not exist on type '{}'.
    errors.notification_recipients.length && (
      // @ts-expect-error - TS2339 - Property 'notification_recipients' does not exist on type '{}'.
      <Errors errors={errors.notification_recipients} />
    );

  return (
    <ContentContainer>
      <StyledFormField>
        <ContentHeader>{t('header')}</ContentHeader>
        <ContentDescription>{t('description')}</ContentDescription>
      </StyledFormField>
      <StyledFormField error={recipientError}>
        <NotificationRecipients
          emails={emails}
          onChangeEmails={onChangeEmails}
          onChangeSelectedUsers={onChangeSelectedUsers}
          selectedUsers={selectedUsers}
        />
      </StyledFormField>
      <StyledFormField
        // @ts-expect-error - TS2339 - Property 'days_of_week' does not exist on type '{}'.
        error={<Errors errors={errors.days_of_week} />}
        data-provides="send-email-on"
      >
        <ContentDescription>
          {`${t('send_on')}: `}
          <Required />
        </ContentDescription>
        <DaysOfWeekPicker
          // @ts-expect-error - TS2339 - Property 'days_of_week' does not exist on type '{}'. | TS2339 - Property 'days_of_week' does not exist on type '{}'.
          hasErrors={errors.days_of_week && errors.days_of_week.length > 0}
          daysOfWeek={daysOfWeek}
          onChange={onChangeDaysOfWeek}
          options={getDaysOfWeekPickerOptions()}
        />
      </StyledFormField>
      <StyledFormField data-provides="send-email-at">
        <ContentDescription>
          {`${t('send_time')}: `} <Required />
        </ContentDescription>
        <div>
          {/* @ts-expect-error - TS2339 - Property 'time' does not exist on type '{}'. | TS2339 - Property 'time' does not exist on type '{}'. */}
          <StyledFormTimeField error={errors.time && errors.time.length > 0}>
            <StyledTimeSelect
              value={time}
              clearable={true}
              onChange={onChangeTime}
              className="time-select"
              data-ref="notifications-time-component"
            />
          </StyledFormTimeField>
          <StyledFormTimeField
            // @ts-expect-error - TS2339 - Property 'time_zone' does not exist on type '{}'. | TS2339 - Property 'time_zone' does not exist on type '{}'.
            error={errors.time_zone && errors.time_zone.length > 0}
          >
            <StyledTimeZoneSelect
              value={timezone}
              clearable={true}
              onChange={onChangeTimezone}
              className="time-zone-select"
              data-ref="notifications-time-zone-component"
            />
          </StyledFormTimeField>
          {timeErrors.length > 0 && <Errors errors={timeErrors} />}
        </div>
      </StyledFormField>
    </ContentContainer>
  );
}

const StyledFormField = styled(FormField)`
  margin-bottom: 16px;
`;

const StyledFormTimeField = styled(FormField)`
  display: inline-block;
  margin-bottom: 0px;
`;

const StyledTimeZoneSelect = styled(TimeZoneSelect)`
  margin-left: 10px;
  width: 325px;
`;
StyledTimeZoneSelect.displayName = 'StyledTimeZoneSelect';

const StyledTimeSelect = styled(TimeSelect)`
  width: 120px;
`;
StyledTimeSelect.displayName = 'StyledTimeSelect';
